
import { routerRedux } from '../../utils'


import {framework_tool} from '../../tool'
let {requestUrl} = framework_tool;


export default {
    namespace: 'sysLogin',

    state: {
        loggedIn: false,
        message: '',
        user: {},
    },

    /**
     * 监听--跳转登录页时清除缓存
     */
    subscriptions: {
        setup({ history, dispatch }) {
            return history.listen((params) => {
                let { pathname } = params;
                if (pathname.indexOf('/login') !== -1) {
                    storage.removeStorage('user');
                    storage.removeStorage('token');
                }
            });
        }
    },

    effects: {
        *login({ payload }, { call, put }) {
            if (network()) {
                const { code, msg, token, data } = yield call(requestUrl.post, constants.urls.kUrlLogin, payload);
                if (code == 0) {
                    storage.setStorage('user', data);
                    storage.setStorage('token', token)
                    yield put({
                        type: 'loginSuccess',
                        payload: data
                    });
                    yield put(routerRedux.replace('/home'));
                } else {
                    yield put({
                        type: 'loginError',
                        payload: { message: msg }
                    });
                }
            } else {
                wizNotice.error('请求失败，当前网络不可用');
            }

        },
        *logout(_, { put }) { }
    },

    reducers: {
        loginSuccess(state, { payload }) {
            return {
                ...state,
                loggedIn: true,
                message: '',
                user: payload
            };
        },
        loginError(state, { payload }) {
            let timeStamp = new Date().getTime();
            return {
                ...state,
                loggedIn: false,
                message: payload.message,
                loginTimeStamp: timeStamp
            };
        },
    }
};
